import React, { useState } from "react";
import Card from "../../../Components/share/cards/Card";
import AdminPagination from "../../../Components/share/Pageination/AdminPagination";
import {
    AiOutlineDownload,
    AiOutlineDown,
    AiOutlineUp,
    AiOutlineFilter,
} from "react-icons/ai";
import TableSort from "../../share/Table/TableSort/TableSort";
import moment from "jalali-moment";

function FileTable(props) {
    const [filter, setFilter] = useState("");
    return (
        <div className="mx-24 py-24">
            <Card className="SupportTicketTable-card SupportTicketTable-header SupportTicketTable-card-Fourcol">
                {header.map((item, id) =>
                    id === 1 ? (
                        <div className=" flex flex-row items-center justify-center cursor-pointer">
                            <div className="dropdown relative">
                                <label
                                    tabindex="0"
                                    className="btn m-1 bg-[#FBF7FF] hover:bg-[#FBF7FF] border-none text-[#212121E5] font-bold text-[1.7rem] leading-[1.8rem]"
                                >
                                    {item.title}
                                    <AiOutlineFilter />
                                </label>
                                <ul
                                    tabindex="0"
                                    className="dropdown-content menu p-2 shadow rounded-[1.6rem] w-[13.2rem] bg-[#FBF7FF] "
                                >
                                    <li
                                        className="border-solid border-b border-[#9C5FA4] text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() =>
                                            setFilter("تکلیف شماره 1")
                                        }
                                    >
                                        <a className="  ">تکلیف شماره 1</a>
                                    </li>
                                    <li
                                        className="border-solid border-b border-[#9C5FA4] text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() =>
                                            setFilter("تکلیف شماره 2")
                                        }
                                    >
                                        <a>تکلیف شماره 2</a>
                                    </li>
                                    <li
                                        className="border-solid border-b border-[#9C5FA4] text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() => setFilter("جلسه دوم")}
                                    >
                                        <a>جلسه دوم</a>
                                    </li>
                                    <li
                                        className="text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() => setFilter("جلسه اول")}
                                    >
                                        <a>جلسه اول</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    ) : id === 2 ? (
                        <div className=" flex flex-row items-center justify-center cursor-pointer">
                            <div className="dropdown relative">
                                <label
                                    tabindex="0"
                                    className="btn m-1 bg-[#FBF7FF] hover:bg-[#FBF7FF] border-none text-[#212121E5] font-bold text-[1.7rem] leading-[1.8rem]"
                                >
                                    {item.title}
                                    <AiOutlineFilter />
                                </label>
                                <ul
                                    tabindex="0"
                                    className="dropdown-content menu p-2 shadow rounded-[1.6rem] w-[13.2rem] bg-[#FBF7FF] "
                                >
                                    <li
                                        className="border-solid border-b border-[#9C5FA4] text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() =>
                                            setFilter("تکلیف شماره 1")
                                        }
                                    >
                                        <a className="  ">تکلیف شماره 1</a>
                                    </li>
                                    <li
                                        className="border-solid border-b border-[#9C5FA4] text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() =>
                                            setFilter("تکلیف شماره 2")
                                        }
                                    >
                                        <a>تکلیف شماره 2</a>
                                    </li>
                                    <li
                                        className="border-solid border-b border-[#9C5FA4] text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() => setFilter("جلسه دوم")}
                                    >
                                        <a>جلسه دوم</a>
                                    </li>
                                    <li
                                        className="text-[#41284E] font-normal text-[1.4rem] leading-[2.4rem]"
                                        onClick={() => setFilter("جلسه اول")}
                                    >
                                        <a>جلسه اول</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    ) : id === 3 ? (
                        <div
                            className={` flex flex-row items-center cursor-pointer text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]`}
                        >
                            {item.title}
                        </div>
                    ) : (
                        <div className="text-[#212121E5] font-bold  leading-[1.8rem] text-[1.7rem]">
                            {item.title}
                        </div>
                    )
                )}
            </Card>

            {props.list?.map((i, id) => (
                <Card className="SupportTicketTable-card SupportTicketTable-body SupportTicketTable-card-Fourcol  my-4">
                    <div className=" cursor-pointer">{"test"}</div>
                    <div>{i?.group_name}</div>
                    <div>{i?.homework_name}</div>
                    <div>
                        {moment(i?.created_at)
                            .locale("fa", { useGregorianParser: true })
                            .format("HH:mm:ss YYYY/MM/DD")}
                    </div>
                    <div>
                        <AiOutlineDownload
                            onClick={() => window.open(``, "_blank")}
                            className="text-[#2D264B] text-[1.8rem] w-[1.8rem] cursor-pointer"
                        />
                    </div>
                </Card>
            ))}
        </div>
    );
}

export default FileTable;

const header = [
    { title: "نام فایل" },
    { title: "نام تیم" },
    { title: "نام تکلیف" },
    { title: "تاریخ بارگزاری" },
];
